import * as TypeGraphQL from "type-graphql";
export var SignalExecutionStatus;
(function (SignalExecutionStatus) {
    SignalExecutionStatus["PENDING"] = "PENDING";
    SignalExecutionStatus["EXECUTED"] = "EXECUTED";
    SignalExecutionStatus["PARTIAL"] = "PARTIAL";
    SignalExecutionStatus["FAILED"] = "FAILED";
    SignalExecutionStatus["CANCELLED"] = "CANCELLED";
})(SignalExecutionStatus || (SignalExecutionStatus = {}));
TypeGraphQL.registerEnumType(SignalExecutionStatus, {
    name: "SignalExecutionStatus",
    description: undefined,
});
//# sourceMappingURL=SignalExecutionStatus.js.map